import isString from 'lodash/isString'
import {parsePhoneNumberFromString} from 'libphonenumber-js'
import matches from 'validator/lib/matches'
import isEmail from 'validator/lib/isEmail'
import isEmpty from 'lodash/isEmpty'
import queryString from "query-string"
import config from '../../../config'

export const DEBOUNCE_DELAY = 750

export const DEFAULT_QR_CODE_SETTINGS = {
  options: {
    margin: 0,
    logoRatio: 4,
    colorDark: null,
    colorLight: null
  },
  logo: false
}

export const composeQrCodeUrl = (shortUrl, settings = {}) => {
  if (isEmpty(settings) || !settings.options) {
    return `${config.api.qrcodeGenerator.baseUrl}/qrcode?shortUrl=${encodeURIComponent(shortUrl)}&source=rb.gy`
  }

  const { options: { margin, size, logoRatio, colorDark, colorLight } = {} } = settings

  let querystring = queryString.stringify(
    {
      size,
      margin,
      colorDark, // encode?
      colorLight, // encode?
      logoRatio,
      shortUrl, // encode?
      source: 'rb.gy'
    },
    {
      skipNull: true,
      skiEmptyString: true
    }
  )
  return `${config.api.qrcodeGenerator.baseUrl}/qrcode?${querystring}`
}

export const buildList = list => list.join(',')

export const isValidPhoneNumbersList = list => {
  if (!list) {
    return false
  }

  let result = true
  list.forEach(e => {
    const phoneNumber = parsePhoneNumberFromString(e)
    // Case for SHORT CODE SMS NUMBERS exception
    // https://github.com/catamphetamine/libphonenumber-js#difference-from-googles-libphonenumber
    if (e.length === 5) {
      result &= matches(e, '^\\+?\\d{5}$')
    } else if (e.length === 6) {
      result &= matches(e, '^\\+?\\d{6}$')
    } else {
      result &= (!!phoneNumber && phoneNumber.isValid())
    }
  })

  return result
}

export const isValidEmailsList = list => {
  if (!list) {
    return false
  }

  let result = true
  list.forEach(e => {
    result &= isEmail(e)
  })

  return result
}
